module.exports = __webpack_public_path__ + "static/media/hangman.39f30daa.png";